import { Navigate } from 'react-router-dom'
import { useQuota } from '../hooks/useQuota.js'

export default function TeacherGuard({ children }) {
  const { isTeacher, loading } = useQuota()

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-spinner" />
      </div>
    )
  }

  if (!isTeacher) {
    return <Navigate to="/perfil" replace />
  }

  return children
}
